const initialStep = true;

/**
 * trainingConfigurationNextButtonReducer: Reducer to handle actions related to the user management button state.
 *
 * @param {any} state - The current state of the user management button.
 * @param {any} action - The action dispatched to the reducer.
 * @returns {any} The new state after applying the action.
 */
const trainingConfigurationNextButtonReducer = (state = initialStep, action: any) => {
  switch (action.type) {
    case "SET_TRAINING_CONFIGURATION_NEXT_BUTTON":
      return action?.payload;
      break;
    default:
      return state;
  }
};

export default trainingConfigurationNextButtonReducer;
